module.exports = __webpack_public_path__ + "static/media/decline.ff23624d.svg";